// extracted by mini-css-extract-plugin
module.exports = {"component":"game-over-overlay_component__LoUcp","active":"game-over-overlay_active__kR_54"};